import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faClock, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';

/**
 * Indicador de estado de la prueba gratuita.
 *
 * Antes era un pill fijo siempre desplegado con el texto completo, sin forma
 * de cerrarlo: en pantallas donde ya hay contenido en esa misma franja (p. ej.
 * la cabecera de Inicio) se montaba encima. Ahora arranca SIEMPRE colapsado
 * (solo el icono, tamaño consistente con el resto de badges de la barra
 * superior) y el mensaje se expande en una tarjeta flotante al hacer clic, en
 * vez de ocupar espacio fijo todo el tiempo.
 */
@Component({
  selector: 'app-trial-status-badge',
  standalone: true,
  imports: [CommonModule, RouterLink, FontAwesomeModule],
  templateUrl: './trial-status-badge.component.html',
  styleUrl: './trial-status-badge.component.css',
})
export class TrialStatusBadgeComponent {
  @Input() message = '';
  @Input() expired = false;
  @Input() daysRemaining: number | null = null;

  faClock = faClock;
  faXmark = faXmark;
  faTriangleExclamation = faTriangleExclamation;

  expanded = false;

  toggle(): void {
    this.expanded = !this.expanded;
  }

  collapse(): void {
    this.expanded = false;
  }
}
